import getSymbolFromCurrency from 'currency-symbol-map';

export function currencyToSymbol(currency: string): string {
  const symbol = getSymbolFromCurrency(currency) || '$';
  if (symbol === '$' && currency && currency !== 'USD') {
    return currency.replace(/D$/, '') + '$';
  }
  return symbol;
}
